import { useState } from "react";

export default function SubscribeStrip() {
  const [email, setEmail] = useState("");
  const [toast, setToast] = useState("");

  const handleSubscribe = () => {
    setToast(
      email.trim()
        ? "已记录你的关注意向，演示模式下暂不发送真实订阅。"
        : "先填一个邮箱试试吧，演示模式下暂不提交。",
    );
    window.setTimeout(() => setToast(""), 2600);
  };

  return (
    <section className="relative overflow-hidden">
      <div className="relative h-auto w-full">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=abstract%20editorial%20banner%20art%20with%20deep%20crimson%20and%20gold%20geometric%20shapes%20on%20warm%20cream%20paper%20texture%2C%20dramatic%20high%20contrast%20grainy%20print%20finish%2C%20no%20text&width=1600&height=600&seq=heiliaoshe-cta-f1&orientation=landscape"
            alt="黑料社网订阅引导"
            title="黑料社网 - 热门爆料头条抢先看"
            className="h-full w-full object-top"
          />
          <div className="absolute inset-0 bg-foreground-950/80" />
        </div>

        <div className="relative mx-auto flex max-w-[1400px] flex-col items-center gap-6 px-4 py-14 text-center md:px-6 md:py-20">
          <span className="inline-flex items-center gap-1.5 rounded-full border border-background-50/30 px-3 py-1 text-xs text-background-100">
            <i className="ri-notification-3-line" />
            新料更新速递
          </span>
          <h2 className="max-w-2xl font-heading text-2xl font-bold leading-snug text-background-50 md:text-4xl">
            不想错过任何一条值得关注的瓜？
          </h2>
          <p className="max-w-xl text-sm leading-relaxed text-background-100/85">
            留下你的邮箱，新料更新与热门爆料头条会第一时间提醒你。我们只推值得看的，不做无关打扰。
          </p>

          <div className="flex w-full max-w-lg flex-col gap-3 sm:flex-row">
            <div className="flex flex-1 items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-4 py-3 backdrop-blur">
              <i className="ri-mail-line text-base text-background-100" />
              <input
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                placeholder="填写你的邮箱地址"
                className="w-full bg-transparent text-sm text-background-50 outline-none placeholder:text-background-100/60"
              />
            </div>
            <button
              type="button"
              onClick={handleSubscribe}
              className="cursor-pointer whitespace-nowrap rounded-full bg-accent-500 px-7 py-3 text-sm font-semibold text-foreground-950 transition-colors hover:bg-accent-400"
            >
              开启更新提醒
            </button>
          </div>

          <span className="flex items-center gap-1.5 text-[11px] text-background-100/60">
            <i className="ri-shield-check-line" />
            演示页面，仅作展示，不会真实提交信息
          </span>
        </div>

        {toast && (
          <div className="absolute inset-x-0 bottom-5 mx-auto w-fit rounded-full bg-background-50 px-5 py-2 text-xs font-medium text-foreground-900">
            {toast}
          </div>
        )}
      </div>
    </section>
  );
}